import { Link } from "react-router-dom";
import { overviewStats, siteInfo } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="paper-grid w-full">
        <div className="grid w-full grid-cols-1 items-center gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-12 lg:px-10 lg:py-20">
          <div className="w-full">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-star-line text-sm"></i>
              </span>
              511 爆料 · 公开求证与时间线档案
            </span>

            <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
              511爆料求证档案
              <span className="mt-2 block text-xl font-semibold text-primary-700 md:text-2xl">
                细节补充 · 时间线整理 · 来源求实 · 证据对照
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              {siteInfo.intro}
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/timeline"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-git-commit-line text-base"></i>
                </span>
                查看事件时间线
              </Link>
              <Link
                to="/evidence"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-800"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-layout-column-line text-base"></i>
                </span>
                进入证据对照室
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                  <i className="ri-checkbox-circle-line text-base"></i>
                </span>
                已登记 {overviewStats[0].value} 条线索
              </span>
              <span className="inline-flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                  <i className="ri-checkbox-circle-line text-base"></i>
                </span>
                全部标注来源等级
              </span>
              <span className="whitespace-nowrap">最近更新：{siteInfo.updatedAt}</span>
            </div>
          </div>

          <div className="relative w-full">
            <div className="h-[320px] w-full overflow-hidden rounded-lg border border-background-300 bg-background-200 md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20stacked%20paper%20documents%20connected%20by%20a%20thin%20red%20thread%2C%20magnifier%20and%20notes%2C%20warm%20rust%20and%20olive%20accents%2C%20cream%20textured%20background%2C%20soft%20natural%20light%2C%20calm%20investigative%20mood%2C%20top%20down%20composition&width=1000&height=1250&seq=qz-hero-main&orientation=portrait"
                alt="511爆料求证档案：纸张线索与时间线梳理工作台"
                title="511爆料时间线整理与来源求实"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-4 left-4 right-4 rounded-md border border-background-200 bg-background-50/95 p-3 backdrop-blur md:left-5 md:right-auto md:w-64 md:p-4">
              <p className="text-[11px] tracking-[0.2em] text-primary-700">
                档案编号 511-TL
              </p>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                依据公开材料整理，每条说法均附来源与可信度标注
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}